export const SET_PILLARS = 'SET_PILLARS';

// initial state
const state = {
    list: {},
    active: {}
}

// getters
const getters = {
    pillars: state => state.list,
    pillar: state => state.active
}

// actions
const actions = {

    getPillars: ({commit, state}, payload) => {
        axios.get(laroute.route('api.pillars.index'))
            .then((response) => {
                commit(SET_PILLARS, {
                    pillars: response.data.data
                });
            })
    }
}

// mutations
const mutations = {
    SET_PILLARS: (state, payload) => {
        state.list = Object.assign({}, state.list, payload.pillars);
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}
